/* eslint-disable */
// src/services/localMachineProfitPercentageService.js

/*
 * Acceso a porcentajes de reparto cliente/dueño por tipo de máquina.
 * getLocalMachineProfitPercentagesByLocal(localId).
 * Complemento necesario para cálculos de recaudación.
 */

import axios from "services/axiosConfig";

const API_URL = "/api/localMachineProfitPercentage";

class LocalMachineProfitPercentageService {
// crear LocalMachineProfitPercentage
  static async createLocalMachineProfitPercentage(localMachineProfitPercentage) {
    try {
      const response = await axios.post(API_URL, localMachineProfitPercentage);
      return response.data;
    } catch (error) {
      console.error("Error al crear la local Machine Profit Percentage:", error);
      throw error;
    }
  }

  // Obtener LocalMachineProfitPercentage por local y por tipo de máquina
static async getLocalMachineProfitPercentageByLocalAndType(localId, machineTypeId) {
  console.log("Verificando LocalId:", localId, "MachineTypeId:", machineTypeId);
  try {
    const response = await axios.get(`${API_URL}/byLocalAndType`, {
      params: { localId, machineTypeId },
    });
    return response.data;
  } catch (error) {
    console.error("Error obteniendo porcentaje de ganancias:", error);
    return null;
  }
}
  
// obtener todos los LocalMachineProfitPercentage
  static async getAllLocalMachineProfitPercentages() {
    try {
      const response = await axios.get(API_URL);
      return response.data;
    } catch (error) {
      console.error("Error al obtener las local Machine Profit Percentages:", error);
      return [];
    }
  }

// obtener un LocalMachineProfitPercentage por id
  static async getLocalMachineProfitPercentageById(id) {
    try {
      const endpoint = `${API_URL}/${id}`;
      const response = await axios.get(endpoint); 
      return response.data;
    } catch (error) {
      console.error("Error al obtener la local Machine Profit Percentage por ID:", error);
      return null;
    }
  }

  // obtener todos los LocalMachineProfitPercentage por localId y join machineType
  static async getLocalMachineProfitPercentagesByLocal(localId) {
    try {
      const endpoint = `${API_URL}/byLocal/${localId}`;
      const response = await axios.get(endpoint);
      return response.data;
    } catch (error) {
      console.error("Error al obtener las máquinas del local por LocalId:", error);
      return [];
    }
  }

// modificar LocalMachineProfitPercentage
  static async updateLocalMachineProfitPercentage(id, localMachineProfitPercentage) {
    try {
      const response = await axios.put(`${API_URL}/${id}`, localMachineProfitPercentage);
      return response.data;
    } catch (error) {
      console.error("Error al editar la local Machine Profit Percentage:", error);
      throw error;
    }
  }

}

export default LocalMachineProfitPercentageService;
